"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps } from "../../lib/inspector";
import { Claim, type ClaimProps } from "./claim";

export type ClaimInspectorProps = BlockInspectorProps;

export function ClaimPreview(props: Readonly<ClaimProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
    locale: props.sys?.locale,
  });

  return (
    <Claim
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
      }}
    />
  );
}
